/**
 * Pill-style toggle button component
 *
 * @param {boolean} active - Whether the toggle is active
 * @param {function} onChange - Called with new active state
 * @param {string} label - Button label (can include count)
 * @param {string} activeLabel - Optional different label when active
 * @param {string} className - Additional classes
 */
const ToggleButton = ({
  active,
  onChange,
  label,
  activeLabel,
  className = "",
}) => {
  return (
    <button
      onClick={() => onChange(!active)}
      className={`px-2 py-1 rounded border text-xs transition-colors ${
        active
          ? "border-primary/30 text-primary bg-primary/5"
          : "border-base-content/10 text-base-content/40 hover:text-base-content/60"
      } ${className}`}
    >
      {active && activeLabel ? activeLabel : label}
    </button>
  );
};

export default ToggleButton;
